import React from 'react';

const PostIconsTitle = (props) => {
    const {
        icons,
    } = props;

    let iconsTitleTag = <div className="cpt-post-icons-title">
        {
            icons.map((item, index) => {
                return (
                    <div
                        className="cpt-post-icons-title-item"
                        key={index}
                    >
                        <span dangerouslySetInnerHTML={{ __html: item.icon }}></span>
                        {item.title}
                    </div>
                );
            })
        }
    </div>
    return iconsTitleTag;
}

export default PostIconsTitle;